import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store =  new Vuex.Store({
    state: {
        token:'',
        rid:'',
        username:'',
        phone:"",
        realname:'',
        avatar:'',
        train_category : '',//培训类型
        train_type : '',//培训方式
        period_category : '',//期次分类
        course_type : '',//课程类型
        organ_category : '',//机构类型
        province : '',//省份
        student_type:'',//学院类型
        config:'',
        routers:''
    },
    mutations: {
        saveLoginInfo(state,status){
            state.token = status.token
            state.rid = String(status.rid)
            state.username = status.username
            state.phone = status.phone
            state.realname = status.realname
            state.avatar = status.avatar
            localStorage.res = JSON.stringify(status)
        },
        deleInfo(state){
            state.token = ''
            state.rid = ''
            state.username = ''
            state.phone = ''
            state.realname = ''
            localStorage.removeItem('res')
        },
        saveConfig(state,status){
            //期次管理相关配置信息object
            state.train_category = JSON.stringify(status.period_config.train_category)//培训类型
            state.train_type = JSON.stringify(status.period_config.train_type)//培训方式
            state.period_category = JSON.stringify(status.period_config.period_category)//期次分类
            state.course_type = JSON.stringify(status.period_config.course_type)//课程类型
            state.organ_category = JSON.stringify(status.organ_category)//机构类型
            state.student_type = JSON.stringify(status.student_type)
            state.config = JSON.stringify(status)
            localStorage.config = JSON.stringify(status)
            localStorage.train_category = JSON.stringify(state.train_category)
            localStorage.train_type = JSON.stringify(state.train_type)
            localStorage.period_category = JSON.stringify(state.period_category)
            localStorage.course_type = JSON.stringify(state.course_type)
            localStorage.organ_category = JSON.stringify(state.organ_category)
            localStorage.student_type = JSON.stringify(state.student_type)
        },
        deleteConfig(state){
            //期次管理相关配置信息object
            state.train_category = ''//培训类型
            state.train_type = ''//培训方式
            state.period_category = ''//期次分类
            state.course_type = ''//课程类型
            state.organ_category = ''//机构类型
            state.student_type = ''//机构类型
            localStorage.removeItem('config')
            localStorage.removeItem('train_category')
            localStorage.removeItem('train_type')
            localStorage.removeItem('period_category')
            localStorage.removeItem('course_type')
            localStorage.removeItem('organ_category')
            localStorage.removeItem('student_type')
        },
        saveProvince(state,status){
            state.province = JSON.stringify(status)
            localStorage.province = JSON.stringify(status)
        },
        deleteProvince(state){
            state.province = ''
            localStorage.removeItem('province')
        },
        saveRouters(state,status){
            //期次管理相关配置信息object
            state.routers = JSON.stringify(status)
            localStorage.routers = JSON.stringify(status)
        },
        deleteRouters(state){
            state.routers = ''
            localStorage.removeItem('routers')
        },
    }
      
})

export default  store 